import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Invoices" hint="Backed by Invoice from the shared finance engine." /> }
